import { reverse } from "./array.js";
import { not } from "./operator.js";
import { isPromise } from "./promise.js";
import { reduce } from "./reduce.js";
import { currentLocation } from "./trace.js";
const pipeWithoutStack = (...fs) => ((...x) => reduce((v, f) => f(v), () => fs[0](...x))(fs.slice(1)));
// deno-lint-ignore no-explicit-any
const augmentAndRethrowException = (location) => (e) => {
    if (e === undefined) {
        console.error(`undefined error within ${location}`);
        throw e;
    }
    try {
        e.message = (e.message ? (e.message + "\n") : "") + location;
    }
    catch (augmentError) {
        console.error(`error within ${location}, gamla could not augment error stack`, augmentError, e);
    }
    throw e;
};
export const errorBoundry = (f) => {
    const location = currentLocation(4);
    return ((...x) => {
        try {
            const result = f(...x);
            return (isPromise(result))
                ? result.catch(augmentAndRethrowException(location))
                : result;
        }
        catch (e) {
            augmentAndRethrowException(location)(e);
        }
    });
};
export const pipe = (...fs) => 
// @ts-ignore-error error in deno but not in node
errorBoundry(pipeWithoutStack(...fs));
export const compose = (...fs) => pipe(...reverse(fs));
export const after = (f) => (g) => pipe(g, f);
export const before = (f1) => (f2) => pipe(f1, f2);
export const complement = (f) => 
// @ts-expect-error compiler cannot dynamically infer
pipe(f, not);
export const sideEffect = (f) => (x) => {
    const result = f(x);
    return (isPromise(result)) ? result.then(() => x) : x;
};
export const wrapSideEffect = (cleanup) => (f) => (...args) => {
    const result = f(...args);
    if (isPromise(result)) {
        return result.then((result) => {
            const cleanUpResult = cleanup(...args);
            return isPromise(cleanUpResult)
                ? cleanUpResult.then(() => result)
                : result;
        });
    }
    else {
        const cleanUpResult = cleanup(...args);
        return isPromise(cleanUpResult) ? cleanUpResult.then(() => result) : result;
    }
};
export const applyTo = (...args) => (f) => f(...args);
export const always = (x) => () => x;
export const identity = (x) => x;
export const thunk = (f) => ((...x) => f()(...x));
